@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_920_806_614)
internal val Res.drawable.A1: DrawableResource by lazy {
      DrawableResource("drawable:A1", setOf(
        ResourceItem(setOf(), "${MD}drawable/A1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-14_896_702)
internal val Res.drawable.A10: DrawableResource by lazy {
      DrawableResource("drawable:A10", setOf(
        ResourceItem(setOf(), "${MD}drawable/A10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-679_239_424)
internal val Res.drawable.A11: DrawableResource by lazy {
      DrawableResource("drawable:A11", setOf(
        ResourceItem(setOf(), "${MD}drawable/A11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-211_332_563)
internal val Res.drawable.A12: DrawableResource by lazy {
      DrawableResource("drawable:A12", setOf(
        ResourceItem(setOf(), "${MD}drawable/A12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(612_075_514)
internal val Res.drawable.A13: DrawableResource by lazy {
      DrawableResource("drawable:A13", setOf(
        ResourceItem(setOf(), "${MD}drawable/A13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(857_941_042)
internal val Res.drawable.A14: DrawableResource by lazy {
      DrawableResource("drawable:A14", setOf(
        ResourceItem(setOf(), "${MD}drawable/A14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_842_576_553)
internal val Res.drawable.A14A: DrawableResource by lazy {
      DrawableResource("drawable:A14A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A14A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_017_837_280)
internal val Res.drawable.A15: DrawableResource by lazy {
      DrawableResource("drawable:A15", setOf(
        ResourceItem(setOf(), "${MD}drawable/A15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_729_997_431)
internal val Res.drawable.A16: DrawableResource by lazy {
      DrawableResource("drawable:A16", setOf(
        ResourceItem(setOf(), "${MD}drawable/A16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-779_944_186)
internal val Res.drawable.A17: DrawableResource by lazy {
      DrawableResource("drawable:A17", setOf(
        ResourceItem(setOf(), "${MD}drawable/A17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(684_218_818)
internal val Res.drawable.A17A: DrawableResource by lazy {
      DrawableResource("drawable:A17A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A17A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_851_534_526)
internal val Res.drawable.A18: DrawableResource by lazy {
      DrawableResource("drawable:A18", setOf(
        ResourceItem(setOf(), "${MD}drawable/A18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_114_875_486)
internal val Res.drawable.A19: DrawableResource by lazy {
      DrawableResource("drawable:A19", setOf(
        ResourceItem(setOf(), "${MD}drawable/A19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(64_772_227)
internal val Res.drawable.A2: DrawableResource by lazy {
      DrawableResource("drawable:A2", setOf(
        ResourceItem(setOf(), "${MD}drawable/A2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_099_999_092)
internal val Res.drawable.A20: DrawableResource by lazy {
      DrawableResource("drawable:A20", setOf(
        ResourceItem(setOf(), "${MD}drawable/A20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(557_698_946)
internal val Res.drawable.A21: DrawableResource by lazy {
      DrawableResource("drawable:A21", setOf(
        ResourceItem(setOf(), "${MD}drawable/A21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(177_104_737)
internal val Res.drawable.A22: DrawableResource by lazy {
      DrawableResource("drawable:A22", setOf(
        ResourceItem(setOf(), "${MD}drawable/A22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-814_076_300)
internal val Res.drawable.A23: DrawableResource by lazy {
      DrawableResource("drawable:A23", setOf(
        ResourceItem(setOf(), "${MD}drawable/A23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-820_584_337)
internal val Res.drawable.A24: DrawableResource by lazy {
      DrawableResource("drawable:A24", setOf(
        ResourceItem(setOf(), "${MD}drawable/A24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_479_975_045)
internal val Res.drawable.A25: DrawableResource by lazy {
      DrawableResource("drawable:A25", setOf(
        ResourceItem(setOf(), "${MD}drawable/A25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(611_154_250)
internal val Res.drawable.A26: DrawableResource by lazy {
      DrawableResource("drawable:A26", setOf(
        ResourceItem(setOf(), "${MD}drawable/A26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-320_269_592)
internal val Res.drawable.A27: DrawableResource by lazy {
      DrawableResource("drawable:A27", setOf(
        ResourceItem(setOf(), "${MD}drawable/A27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-736_263_710)
internal val Res.drawable.A28: DrawableResource by lazy {
      DrawableResource("drawable:A28", setOf(
        ResourceItem(setOf(), "${MD}drawable/A28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_976_046_599)
internal val Res.drawable.A29: DrawableResource by lazy {
      DrawableResource("drawable:A29", setOf(
        ResourceItem(setOf(), "${MD}drawable/A29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_915_680_584)
internal val Res.drawable.A3: DrawableResource by lazy {
      DrawableResource("drawable:A3", setOf(
        ResourceItem(setOf(), "${MD}drawable/A3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_643_526_869)
internal val Res.drawable.A30: DrawableResource by lazy {
      DrawableResource("drawable:A30", setOf(
        ResourceItem(setOf(), "${MD}drawable/A30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-129_949_857)
internal val Res.drawable.A31: DrawableResource by lazy {
      DrawableResource("drawable:A31", setOf(
        ResourceItem(setOf(), "${MD}drawable/A31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(986_700_312)
internal val Res.drawable.A32: DrawableResource by lazy {
      DrawableResource("drawable:A32", setOf(
        ResourceItem(setOf(), "${MD}drawable/A32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(986_095_655)
internal val Res.drawable.A32A: DrawableResource by lazy {
      DrawableResource("drawable:A32A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A32A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_825_379_505)
internal val Res.drawable.A33: DrawableResource by lazy {
      DrawableResource("drawable:A33", setOf(
        ResourceItem(setOf(), "${MD}drawable/A33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-796_255_299)
internal val Res.drawable.A34: DrawableResource by lazy {
      DrawableResource("drawable:A34", setOf(
        ResourceItem(setOf(), "${MD}drawable/A34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_141_466_372)
internal val Res.drawable.A35: DrawableResource by lazy {
      DrawableResource("drawable:A35", setOf(
        ResourceItem(setOf(), "${MD}drawable/A35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_642_414_348)
internal val Res.drawable.A36: DrawableResource by lazy {
      DrawableResource("drawable:A36", setOf(
        ResourceItem(setOf(), "${MD}drawable/A36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_702_656_728)
internal val Res.drawable.A37: DrawableResource by lazy {
      DrawableResource("drawable:A37", setOf(
        ResourceItem(setOf(), "${MD}drawable/A37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_067_237_285)
internal val Res.drawable.A38: DrawableResource by lazy {
      DrawableResource("drawable:A38", setOf(
        ResourceItem(setOf(), "${MD}drawable/A38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_608_919_282)
internal val Res.drawable.A39: DrawableResource by lazy {
      DrawableResource("drawable:A39", setOf(
        ResourceItem(setOf(), "${MD}drawable/A39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(591_367_255)
internal val Res.drawable.A4: DrawableResource by lazy {
      DrawableResource("drawable:A4", setOf(
        ResourceItem(setOf(), "${MD}drawable/A4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-573_298_754)
internal val Res.drawable.A40: DrawableResource by lazy {
      DrawableResource("drawable:A40", setOf(
        ResourceItem(setOf(), "${MD}drawable/A40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_714_521_730)
internal val Res.drawable.A40A: DrawableResource by lazy {
      DrawableResource("drawable:A40A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A40A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_042_210_596)
internal val Res.drawable.A41: DrawableResource by lazy {
      DrawableResource("drawable:A41", setOf(
        ResourceItem(setOf(), "${MD}drawable/A41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(59_810_860)
internal val Res.drawable.A42: DrawableResource by lazy {
      DrawableResource("drawable:A42", setOf(
        ResourceItem(setOf(), "${MD}drawable/A42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_676_665_526)
internal val Res.drawable.A42A: DrawableResource by lazy {
      DrawableResource("drawable:A42A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A42A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_828_577_323)
internal val Res.drawable.A43: DrawableResource by lazy {
      DrawableResource("drawable:A43", setOf(
        ResourceItem(setOf(), "${MD}drawable/A43.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(657_509_202)
internal val Res.drawable.A43A: DrawableResource by lazy {
      DrawableResource("drawable:A43A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A43A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_058_493_163)
internal val Res.drawable.A44: DrawableResource by lazy {
      DrawableResource("drawable:A44", setOf(
        ResourceItem(setOf(), "${MD}drawable/A44.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(57_093_743)
internal val Res.drawable.A45: DrawableResource by lazy {
      DrawableResource("drawable:A45", setOf(
        ResourceItem(setOf(), "${MD}drawable/A45.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(959_849_117)
internal val Res.drawable.A45A: DrawableResource by lazy {
      DrawableResource("drawable:A45A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A45A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-846_417_730)
internal val Res.drawable.A46: DrawableResource by lazy {
      DrawableResource("drawable:A46", setOf(
        ResourceItem(setOf(), "${MD}drawable/A46.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_622_315_683)
internal val Res.drawable.A47: DrawableResource by lazy {
      DrawableResource("drawable:A47", setOf(
        ResourceItem(setOf(), "${MD}drawable/A47.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(828_094_006)
internal val Res.drawable.A48: DrawableResource by lazy {
      DrawableResource("drawable:A48", setOf(
        ResourceItem(setOf(), "${MD}drawable/A48.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(367_950_285)
internal val Res.drawable.A49: DrawableResource by lazy {
      DrawableResource("drawable:A49", setOf(
        ResourceItem(setOf(), "${MD}drawable/A49.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_209_004_321)
internal val Res.drawable.A5: DrawableResource by lazy {
      DrawableResource("drawable:A5", setOf(
        ResourceItem(setOf(), "${MD}drawable/A5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(38_075_995)
internal val Res.drawable.A50: DrawableResource by lazy {
      DrawableResource("drawable:A50", setOf(
        ResourceItem(setOf(), "${MD}drawable/A50.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_980_544_409)
internal val Res.drawable.A51: DrawableResource by lazy {
      DrawableResource("drawable:A51", setOf(
        ResourceItem(setOf(), "${MD}drawable/A51.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_140_126_306)
internal val Res.drawable.A52: DrawableResource by lazy {
      DrawableResource("drawable:A52", setOf(
        ResourceItem(setOf(), "${MD}drawable/A52.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(367_769_064)
internal val Res.drawable.A53: DrawableResource by lazy {
      DrawableResource("drawable:A53", setOf(
        ResourceItem(setOf(), "${MD}drawable/A53.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(665_411_653)
internal val Res.drawable.A54: DrawableResource by lazy {
      DrawableResource("drawable:A54", setOf(
        ResourceItem(setOf(), "${MD}drawable/A54.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-270_029_783)
internal val Res.drawable.A55: DrawableResource by lazy {
      DrawableResource("drawable:A55", setOf(
        ResourceItem(setOf(), "${MD}drawable/A55.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_236_930_768)
internal val Res.drawable.A56: DrawableResource by lazy {
      DrawableResource("drawable:A56", setOf(
        ResourceItem(setOf(), "${MD}drawable/A56.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-456_348_076)
internal val Res.drawable.A57: DrawableResource by lazy {
      DrawableResource("drawable:A57", setOf(
        ResourceItem(setOf(), "${MD}drawable/A57.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_176_427_375)
internal val Res.drawable.A58: DrawableResource by lazy {
      DrawableResource("drawable:A58", setOf(
        ResourceItem(setOf(), "${MD}drawable/A58.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_572_785_118)
internal val Res.drawable.A59: DrawableResource by lazy {
      DrawableResource("drawable:A59", setOf(
        ResourceItem(setOf(), "${MD}drawable/A59.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(990_247_763)
internal val Res.drawable.A5A: DrawableResource by lazy {
      DrawableResource("drawable:A5A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A5A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_923_150_825)
internal val Res.drawable.A6: DrawableResource by lazy {
      DrawableResource("drawable:A6", setOf(
        ResourceItem(setOf(), "${MD}drawable/A6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_599_278_021)
internal val Res.drawable.A60: DrawableResource by lazy {
      DrawableResource("drawable:A60", setOf(
        ResourceItem(setOf(), "${MD}drawable/A60.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_830_136_499)
internal val Res.drawable.A61: DrawableResource by lazy {
      DrawableResource("drawable:A61", setOf(
        ResourceItem(setOf(), "${MD}drawable/A61.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_433_162_834)
internal val Res.drawable.A62: DrawableResource by lazy {
      DrawableResource("drawable:A62", setOf(
        ResourceItem(setOf(), "${MD}drawable/A62.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_728_387_016)
internal val Res.drawable.A63: DrawableResource by lazy {
      DrawableResource("drawable:A63", setOf(
        ResourceItem(setOf(), "${MD}drawable/A63.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_883_451_135)
internal val Res.drawable.A64: DrawableResource by lazy {
      DrawableResource("drawable:A64", setOf(
        ResourceItem(setOf(), "${MD}drawable/A64.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_453_179_690)
internal val Res.drawable.A65: DrawableResource by lazy {
      DrawableResource("drawable:A65", setOf(
        ResourceItem(setOf(), "${MD}drawable/A65.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(387_072_440)
internal val Res.drawable.A66: DrawableResource by lazy {
      DrawableResource("drawable:A66", setOf(
        ResourceItem(setOf(), "${MD}drawable/A66.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(436_850_737)
internal val Res.drawable.A67: DrawableResource by lazy {
      DrawableResource("drawable:A67", setOf(
        ResourceItem(setOf(), "${MD}drawable/A67.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_650_590_772)
internal val Res.drawable.A68: DrawableResource by lazy {
      DrawableResource("drawable:A68", setOf(
        ResourceItem(setOf(), "${MD}drawable/A68.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_633_841_968)
internal val Res.drawable.A69: DrawableResource by lazy {
      DrawableResource("drawable:A69", setOf(
        ResourceItem(setOf(), "${MD}drawable/A69.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_646_516_867)
internal val Res.drawable.A6A: DrawableResource by lazy {
      DrawableResource("drawable:A6A", setOf(
        ResourceItem(setOf(), "${MD}drawable/A6A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(422_028_787)
internal val Res.drawable.A6B: DrawableResource by lazy {
      DrawableResource("drawable:A6B", setOf(
        ResourceItem(setOf(), "${MD}drawable/A6B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-752_983_466)
internal val Res.drawable.A7: DrawableResource by lazy {
      DrawableResource("drawable:A7", setOf(
        ResourceItem(setOf(), "${MD}drawable/A7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(603_525_004)
internal val Res.drawable.A70: DrawableResource by lazy {
      DrawableResource("drawable:A70", setOf(
        ResourceItem(setOf(), "${MD}drawable/A70.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_890_990_318)
internal val Res.drawable.A8: DrawableResource by lazy {
      DrawableResource("drawable:A8", setOf(
        ResourceItem(setOf(), "${MD}drawable/A8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(179_212_438)
internal val Res.drawable.A9: DrawableResource by lazy {
      DrawableResource("drawable:A9", setOf(
        ResourceItem(setOf(), "${MD}drawable/A9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_943_429_744)
internal val Res.drawable.Aa1: DrawableResource by lazy {
      DrawableResource("drawable:Aa1", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-74_506_630)
internal val Res.drawable.Aa10: DrawableResource by lazy {
      DrawableResource("drawable:Aa10", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_260_821_882)
internal val Res.drawable.Aa11: DrawableResource by lazy {
      DrawableResource("drawable:Aa11", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_801_818_741)
internal val Res.drawable.Aa12: DrawableResource by lazy {
      DrawableResource("drawable:Aa12", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_611_795_242)
internal val Res.drawable.Aa13: DrawableResource by lazy {
      DrawableResource("drawable:Aa13", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(594_935_046)
internal val Res.drawable.Aa14: DrawableResource by lazy {
      DrawableResource("drawable:Aa14", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-752_843_091)
internal val Res.drawable.Aa15: DrawableResource by lazy {
      DrawableResource("drawable:Aa15", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-26_192_461)
internal val Res.drawable.Aa16: DrawableResource by lazy {
      DrawableResource("drawable:Aa16", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(206_650_468)
internal val Res.drawable.Aa17: DrawableResource by lazy {
      DrawableResource("drawable:Aa17", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_913_291_959)
internal val Res.drawable.Aa18: DrawableResource by lazy {
      DrawableResource("drawable:Aa18", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(566_980_175)
internal val Res.drawable.Aa19: DrawableResource by lazy {
      DrawableResource("drawable:Aa19", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(733_757_923)
internal val Res.drawable.Aa2: DrawableResource by lazy {
      DrawableResource("drawable:Aa2", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(484_420_474)
internal val Res.drawable.Aa20: DrawableResource by lazy {
      DrawableResource("drawable:Aa20", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-406_726_959)
internal val Res.drawable.Aa21: DrawableResource by lazy {
      DrawableResource("drawable:Aa21", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(634_404_240)
internal val Res.drawable.Aa22: DrawableResource by lazy {
      DrawableResource("drawable:Aa22", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_521_962_052)
internal val Res.drawable.Aa23: DrawableResource by lazy {
      DrawableResource("drawable:Aa23", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_426_774_693)
internal val Res.drawable.Aa24: DrawableResource by lazy {
      DrawableResource("drawable:Aa24", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(897_793_162)
internal val Res.drawable.Aa25: DrawableResource by lazy {
      DrawableResource("drawable:Aa25", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-782_197_518)
internal val Res.drawable.Aa26: DrawableResource by lazy {
      DrawableResource("drawable:Aa26", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(133_661_958)
internal val Res.drawable.Aa27: DrawableResource by lazy {
      DrawableResource("drawable:Aa27", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa27.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("A1", Res.drawable.A1)
  map.put("A10", Res.drawable.A10)
  map.put("A11", Res.drawable.A11)
  map.put("A12", Res.drawable.A12)
  map.put("A13", Res.drawable.A13)
  map.put("A14", Res.drawable.A14)
  map.put("A14A", Res.drawable.A14A)
  map.put("A15", Res.drawable.A15)
  map.put("A16", Res.drawable.A16)
  map.put("A17", Res.drawable.A17)
  map.put("A17A", Res.drawable.A17A)
  map.put("A18", Res.drawable.A18)
  map.put("A19", Res.drawable.A19)
  map.put("A2", Res.drawable.A2)
  map.put("A20", Res.drawable.A20)
  map.put("A21", Res.drawable.A21)
  map.put("A22", Res.drawable.A22)
  map.put("A23", Res.drawable.A23)
  map.put("A24", Res.drawable.A24)
  map.put("A25", Res.drawable.A25)
  map.put("A26", Res.drawable.A26)
  map.put("A27", Res.drawable.A27)
  map.put("A28", Res.drawable.A28)
  map.put("A29", Res.drawable.A29)
  map.put("A3", Res.drawable.A3)
  map.put("A30", Res.drawable.A30)
  map.put("A31", Res.drawable.A31)
  map.put("A32", Res.drawable.A32)
  map.put("A32A", Res.drawable.A32A)
  map.put("A33", Res.drawable.A33)
  map.put("A34", Res.drawable.A34)
  map.put("A35", Res.drawable.A35)
  map.put("A36", Res.drawable.A36)
  map.put("A37", Res.drawable.A37)
  map.put("A38", Res.drawable.A38)
  map.put("A39", Res.drawable.A39)
  map.put("A4", Res.drawable.A4)
  map.put("A40", Res.drawable.A40)
  map.put("A40A", Res.drawable.A40A)
  map.put("A41", Res.drawable.A41)
  map.put("A42", Res.drawable.A42)
  map.put("A42A", Res.drawable.A42A)
  map.put("A43", Res.drawable.A43)
  map.put("A43A", Res.drawable.A43A)
  map.put("A44", Res.drawable.A44)
  map.put("A45", Res.drawable.A45)
  map.put("A45A", Res.drawable.A45A)
  map.put("A46", Res.drawable.A46)
  map.put("A47", Res.drawable.A47)
  map.put("A48", Res.drawable.A48)
  map.put("A49", Res.drawable.A49)
  map.put("A5", Res.drawable.A5)
  map.put("A50", Res.drawable.A50)
  map.put("A51", Res.drawable.A51)
  map.put("A52", Res.drawable.A52)
  map.put("A53", Res.drawable.A53)
  map.put("A54", Res.drawable.A54)
  map.put("A55", Res.drawable.A55)
  map.put("A56", Res.drawable.A56)
  map.put("A57", Res.drawable.A57)
  map.put("A58", Res.drawable.A58)
  map.put("A59", Res.drawable.A59)
  map.put("A5A", Res.drawable.A5A)
  map.put("A6", Res.drawable.A6)
  map.put("A60", Res.drawable.A60)
  map.put("A61", Res.drawable.A61)
  map.put("A62", Res.drawable.A62)
  map.put("A63", Res.drawable.A63)
  map.put("A64", Res.drawable.A64)
  map.put("A65", Res.drawable.A65)
  map.put("A66", Res.drawable.A66)
  map.put("A67", Res.drawable.A67)
  map.put("A68", Res.drawable.A68)
  map.put("A69", Res.drawable.A69)
  map.put("A6A", Res.drawable.A6A)
  map.put("A6B", Res.drawable.A6B)
  map.put("A7", Res.drawable.A7)
  map.put("A70", Res.drawable.A70)
  map.put("A8", Res.drawable.A8)
  map.put("A9", Res.drawable.A9)
  map.put("Aa1", Res.drawable.Aa1)
  map.put("Aa10", Res.drawable.Aa10)
  map.put("Aa11", Res.drawable.Aa11)
  map.put("Aa12", Res.drawable.Aa12)
  map.put("Aa13", Res.drawable.Aa13)
  map.put("Aa14", Res.drawable.Aa14)
  map.put("Aa15", Res.drawable.Aa15)
  map.put("Aa16", Res.drawable.Aa16)
  map.put("Aa17", Res.drawable.Aa17)
  map.put("Aa18", Res.drawable.Aa18)
  map.put("Aa19", Res.drawable.Aa19)
  map.put("Aa2", Res.drawable.Aa2)
  map.put("Aa20", Res.drawable.Aa20)
  map.put("Aa21", Res.drawable.Aa21)
  map.put("Aa22", Res.drawable.Aa22)
  map.put("Aa23", Res.drawable.Aa23)
  map.put("Aa24", Res.drawable.Aa24)
  map.put("Aa25", Res.drawable.Aa25)
  map.put("Aa26", Res.drawable.Aa26)
  map.put("Aa27", Res.drawable.Aa27)
}
